module.exports = __webpack_public_path__ + "static/Mydusa-hero-49b93e911f3844babf0ea70d31effa92.jpg";